<template>
    <div class="table-page">
        <ivuTable border :columns="table.columns" :data="data.plan_detail"></ivuTable>
    </div>
</template>

<script>
    import { Table as ivuTable } from 'iview';
    import tableTag from './tag';
    import { publicMixin } from './mixin/rankMixin';
    export default {
        mixins: [ publicMixin ],
        props: {
            data: {
                required: true,
            },
        },
        created () {
            this.data.plan_detail = [ { content: this.data.plan_detail } ];
            this.data.selectContent = this.getDataProcessing( this.data.plan_detail[ 0 ].content, this.type );
        },
        // eslint-disable-next-line complexity
        data () {
            const pt = this.data.order_info.play_type;
            const lt = this.$route.query.lottery_type
            let ty = ''
            if([ '7', '11' ].includes( lt )){
                ty = pt == '1' ? 3 : pt == '2' ? '3-3' : pt == '3' ? '3-6' : pt == '3' ? '3-6': '4'
            }else if(lt == '8') ty = 5
            else if(lt == '9') ty = 7
            return {
                type: ty,
                table: {
                    columns: [
                        {
                            title: '彩期',
                            minWidth: 90,
                            align: 'center',
                            className: 'touzhuxiang',
                            render: ( h, params ) => h( 'div', `${this.data.order_info.qishu}` ),
                        },
                        {
                            title: '投注选项',
                            align: 'center',
                            minWidth: 500,
                            className: 'touzhuxiang',
                            render: ( h, params ) => h( tableTag, {
                                props: {
                                    row: params.row,
                                    isLottery: this.data.order_info.prize_cash != 0,
                                    data: this.data,
                                    // tp == 1 ? '直选' : tp == 11 ? '直选复式'  : tp == 12 ? '直选和值' : tp == 2 ? '组三' : tp == 3 ? '组六' : tp == 21 ? '组三单式' : '组选和值'
                                    rankZuType: pt == 1 ? '1' : pt == 2 ? '3-3' :  pt == 3 ? '3-6' :  pt == 11 ? '31' : pt == 12 ? '32' : pt == 21 ? '3_31' :'3_32',
                                },
                                style: {
                                    paddingTop: '10px',
                                },
                            } ),
                        },
                        {
                            title: '彩果',
                            align: 'center',
                            minWidth: 200,
                            className: 'spzhi',
                            render: ( h, params ) => {
                                if ( this.data.order_info.prize_cash === 0 ) {
                                    return h( 'div', {
                                        style: {
                                            width: '32px',
                                            height: '2px',
                                            background: 'rgba( 74, 74, 74, 1 )',
                                            borderRadius: '1px',
                                            margin: '0 auto',
                                        },
                                    } );
                                } else {
                                    return h( tableTag, {
                                        props: {
                                            resultFlag: true,
                                            isLottery: false,
                                            row: params.row,
                                            data: this.data,
                                            rankZuType: pt == 1 ? '1' : pt == 2 ? '3-3' :  pt == 3 ? '3-6' :  pt == 11 ? '31' : pt == 12 ? '32' : pt == 21 ? '3_31' :'3_32',
                                        },
                                    } );
                                }
                            },
                        },
                    ],
                },
            };
        },
        components: {
            tableTag, ivuTable,
        },
    };
</script>
<style lang='less' scoped>
  

</style>